/*
 *  <ListCaption> Component
 *
 *  Entitles a section of ListItemDrawer, it has properties including:
 *
 *  children::String - The value of the caption
 *  style::Object    - The style of the component, accept the format
 *    {
 *      container::Object - The style of the root component
 *      caption::Object   - The style of the caption part
 *    }
 *
 *  Basic Usage:
 *    <div className="drawer-group">
 *      <ListCaption>Group A</ListCaption>
 *      <ListItemDrawer title="Title A-A" />
 *      <ListItemDrawer title="Title A-B" />
 *
 *      <ListCaption>Group B</ListCaption>
 *      <ListItemDrawer title="Title B-A" />
 *      <ListItemDrawer title="Title B-B" />
 *
 *      <ListCaption>Group C</ListCaption>
 *      <ListItemDrawer title="Title C-A" />
 *      <ListItemDrawer title="Title C-B" />
 *    </div>
 */

import React from 'react';
import PropTypes from 'prop-types';
import './ListCaption.sass';

const ListCaption = ({
  children,
  style = {}
}) => (
  <div style={style.container || {}} className="ListCaption">
    <h5 style={style.caption || {}}>{ children }</h5>
  </div>
);

ListCaption.propTypes = {
  children: PropTypes.any.isRequired,
  style: PropTypes.shape({
    container: PropTypes.object,
    caption: PropTypes.object
  })
};

ListCaption.defaultProps = {
  style: {}
};

export default ListCaption;



// WEBPACK FOOTER //
// ./src/components/ListCaption.jsx